import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import * as AuthAPI from '../services/authAPI'
import AuthContext from '../context/AuthContext'

export default function Sidebar({ navigate, firstName, lastName, role }) {

    const { setIsAuthenticated } = useContext(AuthContext);
    const location = useLocation();

    const handleLogout = () => {
        AuthAPI.logout();
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
    }

    const isActive = (path) => location.pathname === path;

    const ROLE_LABELS = {
        ROLE_ADMIN: "Administrateur",
        ROLE_MANAGER: "Manager",
        ROLE_FLEET_MANAGER: "Gestionnaire de flotte",
        ROLE_EMPLOYEE: "Employé"
    }

    return (
        <nav id="sidebar" className="sidebar d-flex flex-column flex-shrink-0 bg-white shadow-3">
            {/* Logo / Brand */}
            <div className="sidebar-header d-flex align-items-center justify-content-center py-4 px-3 border-bottom">
                <Link to="/" className="text-decoration-none">
                    <span className="fw-bold text-primary fs-5">Monitor</span>
                </Link>
            </div>

            {/* User info */}
            <div className="d-flex align-items-center px-3 py-3 border-bottom">
                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3"
                     style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                    <span className="text-white fw-bold" style={{ fontSize: '14px' }}>
                        {firstName?.charAt(0)}{lastName?.charAt(0)}
                    </span>
                </div>
                <div className="overflow-hidden">
                    <p className="mb-0 fw-bold text-truncate" style={{ fontSize: '14px' }}>{firstName} {lastName}</p>
                    <small className="text-muted">{ROLE_LABELS[role]}</small>
                </div>
            </div>

            {/* Navigation links */}
            <ul className="nav flex-column px-2 pt-3 flex-grow-1">
                <li className="nav-item mb-1">
                    <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/dashboard') ? 'active bg-primary text-white' : 'text-dark'}`} to="/dashboard">
                        <i className="fas fa-chart-line me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                        <span>Tableau de bord</span>
                    </Link>
                </li>
                                <li className="nav-item mb-1">
                    <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/tickets') ? 'active bg-primary text-white' : 'text-dark'}`} to="/tickets">
                        <i className="fas fa-ticket-alt me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                        <span>Tickets</span>
                    </Link>
                </li>
                                <li className="nav-item mb-1">
                    <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/vehicles') ? 'active bg-primary text-white' : 'text-dark'}`} to="/vehicles">
                        <i className="fas fa-car me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                        <span>Véhicules</span>
                    </Link>
                </li>
                <li className="nav-item mb-1">
                    <Link className={`nav-link sidebar-link rounded-3 d-flex align-items-center ${isActive('/users') ? 'active bg-primary text-white' : 'text-dark'}`} to="/users">
                        <i className="fas fa-users me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                        <span>Utilisateurs</span>
                    </Link>
                </li>
            </ul>

            {/* Bottom section */}
            <div className="border-top px-2 py-3">
                <Link className="nav-link sidebar-link rounded-3 d-flex align-items-center mb-1 text-dark" to="/help">
                    <i className="fas fa-question-circle me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                    <span>Aide</span>
                </Link>
                <button onClick={handleLogout} className="nav-link sidebar-link rounded-3 d-flex align-items-center text-danger w-100 border-0 bg-transparent">
                    <i className="fas fa-sign-out-alt me-3" style={{ width: '20px', textAlign: 'center' }}></i>
                    <span>Deconnexion</span>
                </button>
            </div>
        </nav>
    )
}
